import { render, staticRenderFns } from "./TotalModule.vue?vue&type=template&id=17b73382&scoped=true&"
import script from "./TotalModule.vue?vue&type=script&lang=js&"
export * from "./TotalModule.vue?vue&type=script&lang=js&"
import style0 from "./TotalModule.vue?vue&type=style&index=0&id=17b73382&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b73382",
  null
  
)

export default component.exports